// Backend API Configuration
// Production: uses the same domain as frontend (proxied by nginx)
// Development: uses localhost:6001
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 
  (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:6001');

// Axios base URL for API calls
export const API_BASE_URL = BACKEND_URL + '/api';

export default {
  BACKEND_URL,
  API_BASE_URL
};
